import React from "react";
import { useSelector } from "react-redux";
import { formatDateLabelValue } from "us.common/functions";

export default ({ value, ...rest }: any) => {
  const { currentDateFormat } = useSelector((state: any) => state.common);

  return (
    <React.Fragment {...rest}>
      {formatDateLabelValue(value, currentDateFormat)}
    </React.Fragment>
  );
};
